import _ from "lodash";
import {actionStatusChange, applyActionRules, storedActionsById} from "./actionRules";
import {refreshWorkItemStatus} from "./status";
import {statusMessage} from "./followUp";

// Action : étape d'un work item ou action rapide d'une opportunité.
// Les champs workItem / opportunity sont créés par les liens OTM des parents (côté enfant).
export const entity = {
    name: 'Action',
    facets: ['conversations'],
    fields: [
        'name',
        {path: 'type', type: 'ActionType', nullable: true},
        {path: 'order', type: 'integer', default: 0},
        {path: 'assignee', type: 'User', nullable: true},
        {path: 'status', type: 'ActionStatus'},
        {path: 'startDate', type: 'date', nullable: true},
        {path: 'dueDate', type: 'date', nullable: true},
        {path: 'doneDate', type: 'date', nullable: true},
        {path: 'numberOfRevisions', type: 'integer', default: 0},
        'description',
        {
            path: 'context',
            fieldPath: ['workItem.code', 'workItem.name', 'opportunity.code', 'opportunity.name'],
            f: function() {
                const parent = this.workItem || this.opportunity
                return parent ? `${parent.code} - ${parent.name}` : ''
            }
        }
    ],
    filters: [
        {
            name: 'onlyAssignedToUser',
            isDefault: false,
            query: function(context) {
                const userId = _.get(context, 'user.id')
                return userId ? {assignee: new global.ObjectID(userId)} : {_id: null}
            }
        },
        {
            name: 'onlyOpen',
            isDefault: false,
            query: function() {
                return {status: {$in: ['todo', 'ongoing', 'blocked']}}
            }
        }
    ],
    beforeSave: async function(newObject, oldObject, context, callback) {
        try {
            const stored = await storedActionsById([newObject.id])
            applyActionRules(newObject, stored[newObject.id])

            // « Suivi » du formulaire de l'action : le changement de statut y est tracé
            const change = actionStatusChange(newObject, stored[newObject.id])
            if (change) newObject.conversations = [
                ...(newObject.conversations || []),
                statusMessage(change.from, change.to, 'ActionStatus', context)
            ]
            callback(null, newObject, oldObject)
        } catch (error) {
            callback(error)
        }
    },
    afterSave: async function(newObject, oldObject, context, callback) {
        try {
            const stored = await global.app.K.Action.collection.findOne(
                {_id: new global.ObjectID(newObject.id)},
                {projection: {workItem: 1}}
            )
            if (stored && stored.workItem) await refreshWorkItemStatus(stored.workItem, context)
            callback()
        } catch (error) {
            callback(error)
        }
    }
}

// « Action » : les actions affectées à l'utilisateur, créées depuis un work item ou une opportunité
export const module_ = {
    object: 'Action',
    tKey: 'action',
    category: {
        path: 'work',
        icon: 'check-square'
    },
    newable: false,
    removable: false,
    defaultSortBy: 'dueDate',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            'context',
            'type',
            'name',
            'status',
            'dueDate',
            {path: 'doneDate', initiallyNotVisible: true},
            {path: 'numberOfRevisions', tKey: 'Révision(s)', initiallyNotVisible: true}
        ],
        form: [
            {path: 'context', disabled: true},
            {path: 'type', display: 'fullName', disabled: true},
            {path: 'name', disabled: true},
            {path: 'description', tKey: 'synthèse', type: 'richTextEditor'},
            'status',
            'startDate',
            'dueDate',
            {path: 'conversations', tKey: 'suivi'}
        ]
    },
    filters: [
        {
            // par défaut l'utilisateur connecté ; un responsable peut consulter les actions d'un collègue
            path: 'assignee',
            object: 'User',
            display: 'name',
            client: true,
            clearable: true,
            placeholder: 'selectUser',
            default: {id: null},
            query: function(context) {
                const userId = _.get(context.data, 'assignee.id') || _.get(context, 'user.id')
                return userId ? {assignee: new global.ObjectID(userId)} : {_id: null}
            }
        },
        {
            path: 'statusAction',
            tKey: 'status',
            object: 'ActionStatus',
            display: 'name',
            client: true,
            type: 'tags',
            clearable: true,
            placeholder: 'selectActionStatus',
            default: [{id: 'todo'}, {id: 'ongoing'}, {id: 'blocked'}],
            query: function(context) {
                const actionStatuses = _.get(context.data, 'statusAction') || []
                if (actionStatuses.length)
                    return { status: {$in: actionStatuses.map(o => o.id)} }
                return {}
            }
        }
    ]
}
